"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DigitalSpoils() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="283" id="digital-spoils" className="bg-background text-foreground relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-5 min-h-screen">
        {}
        <div className="lg:col-span-3 relative overflow-hidden h-[60vh] lg:h-auto lg:min-h-screen">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/pixel_force_victory_moment.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/pixel_force_victory_moment.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/pixel_force_victory_moment.png-wvc-sizes" alt="Esports team celebrating a tournament victory under neon lights" loading="lazy" decoding="async" className={`absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out ${isVisible ? "scale-100" : "scale-110"}`} />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background/40 pointer-events-none" />
        </div>

        {}
        <div ref={ref} className={`lg:col-span-2 flex items-center px-6 py-16 sm:px-10 lg:px-16 lg:py-24 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="max-w-xl">
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-8 bg-primary" />
              <p className="font-default text-xs tracking-[0.25em] uppercase" style={{
              color: "var(--primary)"
            }}>
                Community Intel · Season 04
              </p>
            </div>

            {}
            <h2 className="font-default text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-foreground mb-10">
              <span className="italic font-light">Digital</span>
              <span className="block font-normal">Spoils Await</span>
            </h2>

            {}
            <div className="space-y-5 font-default text-base sm:text-lg leading-relaxed text-foreground/70">
              <p>
                Every season, the Pixel Force command center releases exclusive assets 
                for our community. It starts with a encrypted signal — a notification 
                that the vault is open for our most dedicated supporters.
              </p>

              <p>
                These are not standard wallpapers. They are high-resolution, 
                tactical-grade renders of our pro-player setups, tournament arenas, 
                and custom neon-infused branding, optimized for your battle station.
              </p>

              <blockquote className="relative my-8 pl-6 border-l-2 border-primary/60">
                <p className="font-default italic text-xl sm:text-2xl leading-snug" style={{
                color: "var(--primary)"
              }}>
                  "Victory is earned in the arena, but style is forged in the code."
                </p>
              </blockquote>

              <p>
                We curate these files with precision, ensuring every pixel reflects 
                the intensity of our competitive spirit. From 4K desktop backgrounds 
                to mobile HUD overlays, these assets are designed to keep you 
                connected to the Force.
              </p>

              <p>
                Download the collection now and upgrade your setup to match the 
                standard of a professional esports organization.
              </p>
            </div>

            {}
            <div className="mt-12 pt-8 border-t border-border/50">
              <div className="flex items-center gap-4">
                <SafeHydrate><Avatar className="size-[60px] border border-border/60">
                  <AvatarImage src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/pixel_force_founder_avatar.png" alt="Pixel Force Founder portrait" />
                  <AvatarFallback className="bg-muted text-foreground font-default">
                    PF
                  </AvatarFallback>
                </Avatar></SafeHydrate>
                <div>
                  <p className="font-default italic text-foreground/90 text-base">
                    — The Pixel Force Command
                  </p>
                  <p className="font-default text-xs tracking-widest uppercase text-foreground/50 mt-1">
                    Authorized Access Only
                  </p>
                </div>
              </div>

              {}
              <Link to="/TheHolodeckPage" className="group inline-flex items-center gap-2 mt-8 font-default text-xs tracking-[0.2em] uppercase text-foreground/70 hover:text-primary transition-colors">
                <span className="relative">
                  Download Desktop Assets
                  <span className="absolute left-0 -bottom-1 h-px w-0 bg-primary transition-all duration-500 ease-out group-hover:w-full" />
                </span>
                <ArrowRight className="size-3.5 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}